import React from "react";
import ReactApexChart from "react-apexcharts";

const BarChart = ({
  labels = [],
  seriesData = [],
  colourTheme = ["#25CD25", "#FF4D4F"],
  title = "",
}) => {
  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 4,
      },
    },
    colors: colourTheme,
    xaxis: {
      categories: labels,
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: { show: true },
    },
    yaxis: {
      labels: { formatter: (val) => `${val}` },
    },
    dataLabels: { enabled: false },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    legend: { show: false },
    grid: {
      show: true,
      borderColor: "#CCCCCC",
      strokeDashArray: 10,
      strokeWidth: 0.5,
    },
  };

  return (
    <div style={{ width: "100%" }}>
      {title && (
        <div>
          <h3
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: "20px",
              margin: 0,
              color: "black",
            }}
          >
            {title}
          </h3>
        </div>
      )}

      <ReactApexChart
        options={options}
        series={seriesData}
        type="bar"
        height={160}
      />
    </div>
  );
};

export default BarChart;
